import React, { useState, useRef } from 'react';
import FocusTrap from 'focus-trap-react';
import { ICONS } from 'constants/icons';
import { useField } from 'react-final-form';
import { TONE_OF_VOICE_OPTIONS } from './constants';
import * as Styled from './ToneOfVoiceDropdown.styled';

interface ToneOfVoiceDropdownProps {
  fieldName: string;
  disabled?: boolean;
  className?: string;
}

export const ToneOfVoiceDropdown: React.FC<ToneOfVoiceDropdownProps> = ({
  fieldName,
  disabled = false,
  className,
}) => {
  const {
    input: { value, onChange },
  } = useField(fieldName);

  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const selectedOption = TONE_OF_VOICE_OPTIONS.find(
    option => option.key === value,
  );

  return (
    <Styled.DropdownWrapper ref={wrapperRef} className={className}>
      <FocusTrap
        active={isOpen}
        focusTrapOptions={{
          clickOutsideDeactivates: true,
          onDeactivate: () => setIsOpen(false),
        }}
      >
        <div tabIndex={-1}>
          <Styled.DropdownInput
            type="button"
            aria-haspopup="listbox"
            aria-expanded={isOpen}
            onClick={() => setIsOpen(open => !open)}
            disabled={disabled}
            style={{ position: 'relative' }}
          >
            <Styled.DropdownText>
              <Styled.Label>Tone of voice:</Styled.Label>{' '}
              <Styled.SelectedValue>
                {selectedOption
                  ? selectedOption.label
                  : TONE_OF_VOICE_OPTIONS[0].label}
              </Styled.SelectedValue>
            </Styled.DropdownText>
            <Styled.StyledCaret
              name={ICONS.CARET_DOWN}
              open={isOpen}
              aria-hidden
            />
          </Styled.DropdownInput>
          <Styled.DropdownList open={isOpen} role="listbox" tabIndex={-1}>
            {TONE_OF_VOICE_OPTIONS.map(option => (
              <Styled.Option
                key={option.key}
                type="button"
                role="option"
                aria-selected={value === option.key}
                selected={value === option.key}
                onClick={() => {
                  onChange(option.key);
                  setIsOpen(false);
                }}
                tabIndex={0}
              >
                {option.label}
              </Styled.Option>
            ))}
          </Styled.DropdownList>
        </div>
      </FocusTrap>
    </Styled.DropdownWrapper>
  );
};
